<template>
  <div class="history">
    <div class="header shadow-3">
      <q-separator></q-separator>
      <div class="title">VER HISTÓRICO DA ÚLTIMA VIAGEM</div>
      <div style="padding-left: 30px" v-if="valuesTitle()">
        <div
          class="text-subtitle2 text-weight-bold"
          style="color: #172C20"
        >{{ valuesTitle().description }}</div>
        <span style="color: #7A8583;">
          Saída dia
          <span class="text-weight-bold">{{ valuesTitle().departure_date }}</span>
        </span>
        <span style="color: #7A8583;">
          ás
          <span class="text-weight-bold">{{ valuesTitle().departure_time }}</span>
        </span>
      </div>
      <div  style="padding-left: 30px" v-else>
        Não encontramos um histórico
      </div>
    </div>
    <div class="histories q-gutter-y-md q-my-none">
      <q-list v-for="(history, index) in historiesTravel" :key="index">
        <q-card
          clickable
          @click="history.passengers ? $router.push(`/history-passengers/${index}`) : false"
          class="histories__grid items-center no-shadow"
        >
          <div>
            <i class="ri-history-line icon"></i>
          </div>
          <div>
            <span>Viagem de:</span>
            <div>
              <span
                class="text-black text-weight-bold"
              >{{history.boarding_name+"-"+history.boarding_uf}}</span> para
              <br />
              <span
                class="text-black text-weight-bold"
              >{{history.landing_name+"-"+history.landing_uf}}</span>
            </div>
            <span style="color: #808285">{{converterDataMask(history.departure_datetime)}}</span>
          </div>
          <div>
            <q-btn
              v-if="history.passengers !== null"
              :to="`/history-passengers/${index}`"
              unelevated
              label="Detalhes"
              no-caps
              style="background-color: #23C400; color:white; font-weight: 600"
            />
          </div>
        </q-card>
      </q-list>
    </div>
  </div>
</template>

<script>
import { date } from "quasar";
import { getLocalStorage } from "../functions";
import { HISTORY_TRAVEL } from "../variables";

export default {
  name: "HistoryTravel",
  computed: {
    historiesTravel: {
      get() {
        return getLocalStorage(HISTORY_TRAVEL)
          ? getLocalStorage(HISTORY_TRAVEL)
          : [];
      },
    },
  },
  methods: {
    converterDataMask(datetime) {
      const dateLocal = datetime.split("T")[0];
      const hour = datetime.split("T")[1];
      const dataLocal = new Date(Date.parse(dateLocal + " " + hour)).toString();
      const dataEUA = dataLocal.split("/").reverse().join("/");
      return (
        "Dia " +
        date.formatDate(dataEUA, "D MMMM YYYY") +
        " - " +
        hour.slice(0, -4)
      );
    },
    valuesTitle() {
      if (this.historiesTravel && this.historiesTravel.length > 0) {
        return {
          description: this.historiesTravel[0].description,
          departure_date: this.historiesTravel[0].departure_date
            .split("T")[0]
            .split("-")
            .reverse()
            .join("/"),
          departure_time: this.historiesTravel[0].departure_time.slice(0, 5),
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.history {
  display: grid;
  grid-template-rows: 1fr;

  .header {
    background: white;
    height: 120px;
    .title {
      color: #808285;
      font-weight: 550;
      padding: 30px 30px 10px 30px;
    }
  }
  .histories {
    height: 100%;
    background: #e5e5e5;
    padding: 0 20px 20px 20px;
    min-height: 100vh;

    .histories__grid {
      display: grid;
      grid-template-columns: max-content 1fr max-content;
      gap: 20px;
      padding: 10px;

      .icon {
        color: #808285;
        font-size: 25px;
      }
    }
  }
}
</style>